import React, { useEffect, useRef, useState } from "react";
import "./topBands.css";
import dashboardService from "services/dashboard.service";

interface MetalData {
  metal: string;
  inStock: boolean;
  digiMsg: string | null;
  deliMsg: string | null;
}

const TopBands: React.FC = () => {
  const [currentMessage, setCurrentMessage] = useState<string | null>(null);
  const [isActive, setIsActive] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  /** Fetch stock status */
  const fetchStockStatus = async () => {
    try {
      const response = await dashboardService.isStockAvailable();
      const data: MetalData[] = response?.data?.data || [];

      const outOfStockData = data.find(
        (item) => item.inStock === false && (item.digiMsg || item.deliMsg)
      );

      if (outOfStockData) {
        setCurrentMessage(outOfStockData.digiMsg || outOfStockData.deliMsg);
        setIsActive(true);
      } else {
        setCurrentMessage(null);
        setIsActive(false);
      }
    } catch (error) {
      console.error("Error fetching stock status:", error);
      setCurrentMessage(null);
      setIsActive(false);
    }
  };

  /** Initial fetch + polling */
  useEffect(() => {
    fetchStockStatus();
    const interval = setInterval(fetchStockStatus, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`top-bands ${isActive ? "alert-active" : "alert-inactive"}`}>
      {currentMessage && (
        <div className="scrolling-wrapper">
          <div className="scrolling-container" ref={containerRef}>
            <div className="scrolling-message">
              <span>⚠️ {currentMessage}&nbsp;&nbsp;&nbsp;</span>
              <span>⚠️ {currentMessage}&nbsp;&nbsp;&nbsp;</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopBands;
